import resolver, {ResolverSettings} from './utils/resolver';
import {GuestTaxExemption} from '../utils/types';

type CalculateGuestTaxPayload = {
  id?: string;
  calculate_only?: boolean;
  guest_list?: Partial<GuestTaxExemption>[];
  reservation_id: string;
  status?: 'PENDING' | 'COMPLETE';
};

class TaxesApi {
  ENDPOINTS = {
    allExemptions: (params = '') => `stat-tax-exemptions/?${params}`,
    exemptions: (id = '') => `seasons/${id}/exemptions/`,
    season: (id: string) => `seasons/${id}/`,
    seasonGuests: (params = '') => `season-guests/?${params}`,
    guestTaxes: (id = '', params = '') => `season-guests/${id}/?${params}`,
    initGuestTaxes: () => `season-guests/init/`,
  };

  getAllExemptions<T>(params = '', resolverSettings?: ResolverSettings) {
    return resolver<T>(this.ENDPOINTS.allExemptions(params), null, resolverSettings);
  }

  getExemptions<T>(id = '', resolverSettings?: ResolverSettings) {
    return resolver<T>(this.ENDPOINTS.exemptions(id), null, resolverSettings);
  }

  getSeason<T>(id: string, resolverSettings?: ResolverSettings) {
    return resolver<T>(this.ENDPOINTS.season(id), null, resolverSettings);
  }

  getSeasonGuests<T>(params = '', resolverSettings?: ResolverSettings) {
    return resolver<T>(this.ENDPOINTS.seasonGuests(params), null, resolverSettings);
  }

  initGuestTaxes<T>(
    payload: {reservation_id: string},
    resolverSettings?: ResolverSettings,
  ) {
    return resolver<T>(
      this.ENDPOINTS.initGuestTaxes(),
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      resolverSettings,
    );
  }

  calculateGuestTax<T>(
    {id, ...payload}: CalculateGuestTaxPayload,
    params?: string,
    resolverSettings?: ResolverSettings,
  ) {
    if (id) {
      return resolver<T>(
        this.ENDPOINTS.guestTaxes(id, params),
        {
          method: 'PATCH',
          body: JSON.stringify(payload),
        },
        resolverSettings,
      );
    } else {
      return resolver<T>(
        this.ENDPOINTS.seasonGuests(params),
        {
          method: 'POST',
          body: JSON.stringify(payload),
        },
        resolverSettings,
      );
    }
  }
}

export {TaxesApi};
export type {CalculateGuestTaxPayload};
